// src/components/Topbar.jsx
import { useEffect } from "react";

export default function Topbar({ onMenu, title = "Painel" }) {
  // Fecha o teclado móvel ao navegar (quality of life)
  useEffect(() => {
    const close = () => document.activeElement?.blur?.();
    window.addEventListener("hashchange", close);
    return () => window.removeEventListener("hashchange", close);
  }, []);

  // Mantém o título da aba sincronizado (opcional, não quebra nada)
  useEffect(() => {
    const old = document.title;
    document.title = title ? `${title} — Remote Admin` : "Remote Admin";
    return () => { document.title = old; };
  }, [title]);

  return (
    <header
      className="
        md:hidden sticky top-0 z-40
        bg-white/90 dark:bg-zinc-900/90
        backdrop-blur supports-[backdrop-filter]:backdrop-blur
        border-b border-zinc-200 dark:border-zinc-800
        px-4 py-3 flex items-center gap-3
        [padding-top:calc(env(safe-area-inset-top)+0.75rem)]
      "
    >
      <button
        onClick={onMenu}
        aria-label="Abrir menu"
        aria-haspopup="dialog"
        className="
          p-2 rounded-lg border border-zinc-200 dark:border-zinc-700
          active:scale-[0.98] transition
        "
      >
        {/* ícone hambúrguer */}
        <span className="block w-5 h-0.5 bg-zinc-900 dark:bg-zinc-100 mb-1" />
        <span className="block w-5 h-0.5 bg-zinc-900 dark:bg-zinc-100 mb-1" />
        <span className="block w-5 h-0.5 bg-zinc-900 dark:bg-zinc-100" />
      </button>

      <h1 className="text-base font-semibold text-zinc-900 dark:text-zinc-100 truncate">
        {title}
      </h1>
    </header>
  );
}
